class CookieBanner extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      activeClass: 'is-active',
      closingClass: 'is-closing'
    };

    this.banner = this.querySelector('.cookie-banner');
    this.modal = this.querySelector('.cookie-modal');

    this.acceptButtons = this.querySelectorAll('[name="accept"]');
    this.customizeButton = this.querySelector('[name="customize"]');
    this.saveButton = this.querySelector('[name="save_preferences"]');
    this.closeButtons = this.querySelectorAll('[data-cookie-close]');
    this.categoryToggles = this.querySelectorAll('.cookie-category__toggle');
    this.readMoreButton = this.querySelector('[data-cookie-read-more]');
    this.readMoreContent = this.querySelector('.cookie-intro__more');

    if (this.dataset.testMode === 'true') {
      this.init();
      this.bindEvents();
    } else {
      window.Shopify.loadFeatures([
        {
          name: 'consent-tracking-api',
          version: '0.1',
        }
      ], (error) => {
        if (error) {
          throw error;
        }

        this.beforeInit();
      });
    }
  }

  connectedCallback() {
    if (Shopify.designMode) {
      this.onShopifySectionSelect = this.onSectionSelect.bind(this);
      this.onShopifySectionDeselect = this.onSectionDeselect.bind(this);

      document.addEventListener('shopify:section:select', this.onShopifySectionSelect);
      document.addEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
    }
  }

  disconnectedCallback() {
    if (Shopify.designMode) {
      document.removeEventListener('shopify:section:select', this.onShopifySectionSelect);
      document.removeEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
    }
  }

  onSectionSelect() {
    this.open();
  }

  onSectionDeselect() {
    this.close();
    this.closeModal();
  }

  beforeInit() {
    const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
    const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();

    if (
      !window.location.pathname.match(/^(\/[a-z]{2}(-[A-Z]{2})?)?\/cart$/) &&
      !userCanBeTracked &&
      userTrackingConsent === 'no_interaction'
    ) {
      this.init();
      this.bindEvents();
    }
  }

  bindEvents() {
    this.acceptButtons.forEach((button) => {
      button.addEventListener('click', this.acceptAll.bind(this));
    });

    if (this.customizeButton) {
      this.customizeButton.addEventListener('click', this.openModal.bind(this));
    }

    if (this.saveButton) {
      this.saveButton.addEventListener('click', this.savePreferences.bind(this));
    }

    this.closeButtons.forEach((button) => {
      button.addEventListener('click', this.closeModal.bind(this));
    });

    this.categoryToggles.forEach((button) => {
      button.addEventListener('click', () => {
        const category = button.closest('.cookie-category');
        const icon = button.querySelector('span');

        if (!category) return;

        category.classList.toggle('is-open');

        if (icon) {
          icon.textContent = category.classList.contains('is-open') ? '⌄' : '›';
        }
      });
    });

    if (this.readMoreButton && this.readMoreContent) {
      this.readMoreButton.addEventListener('click', () => {
        const isHidden = this.readMoreContent.hasAttribute('hidden');

        if (isHidden) {
          this.readMoreContent.removeAttribute('hidden');
          this.readMoreButton.textContent = 'Rodyti mažiau';
        } else {
          this.readMoreContent.setAttribute('hidden', true);
          this.readMoreButton.textContent = 'Rodyti daugiau';
        }
      });
    }
  }

  init() {
    if (Shopify && Shopify.designMode) {
      return;
    }

    setTimeout(() => {
      this.open();
    }, parseInt(this.dataset.delay) * 1000);
  }

  open() {
    if (this.banner) {
      this.banner.classList.add(this.classes.activeClass);
    }
  }

  close() {
    if (!this.banner) return;

    this.banner.classList.add(this.classes.closingClass);

    setTimeout(() => {
      this.banner.classList.remove(this.classes.activeClass);
      this.banner.classList.remove(this.classes.closingClass);
    }, 500);
  }

  openModal(event) {
    if (event) event.preventDefault();

    if (this.modal) {
      this.modal.removeAttribute('hidden');
    }
  }

  closeModal(event) {
    if (event) event.preventDefault();

    if (this.modal) {
      this.modal.setAttribute('hidden', true);
    }
  }

  acceptAll(event) {
    if (event) event.preventDefault();

    this.setConsent({
      analytics: true,
      marketing: true,
      preferences: true
    });

    this.closeModal();
    this.close();
  }

  savePreferences(event) {
    if (event) event.preventDefault();

    const analytics = this.querySelector('[data-cookie-analytics]')?.checked || false;
    const marketing = this.querySelector('[data-cookie-marketing]')?.checked || false;
    const preferences = this.querySelector('[data-cookie-preferences]')?.checked || false;

    this.setConsent({
      analytics: analytics,
      marketing: marketing,
      preferences: preferences
    });

    this.closeModal();
    this.close();
  }

  setConsent(consent) {
    if (!window.Shopify || !window.Shopify.customerPrivacy) {
      return;
    }

    window.Shopify.customerPrivacy.setTrackingConsent(
      {
        analytics: consent.analytics,
        marketing: consent.marketing,
        preferences: consent.preferences
      },
      this.noop
    );
  }

  noop() {}
}

customElements.define('cookie-banner', CookieBanner);